import { Box } from "@mui/material";
import { PropsWithChildren } from "react";

const FRAME_SHADOW = "0px 3px 6px -2px rgba(0, 0, 0, 0.2)";

type ContentFrameProps = PropsWithChildren<{
    /** Chrome dimensions the frame must clear, in px. */
    topbarHeight: number;
    sidebarWidth: number;
}>;

/**
 * The framed paper region shared by every route — always position fixed, so
 * collapsing the sidebar is a pure CSS `inset` transition and children stay
 * mounted.
 */
export function ContentFrame({ children, topbarHeight, sidebarWidth }: ContentFrameProps) {
    return (
        <Box
            sx={theme => ({
                position: "fixed",
                inset: { xs: `${topbarHeight}px 0 0 0`, sm: `${topbarHeight}px 0 0 ${sidebarWidth}px` },
                p: { xs: 0, sm: "4px 4px 4px 0px" },
                minHeight: 0,
                display: "flex",
                flexDirection: "column",
                transition: theme.transitions.create(["inset", "padding"], {
                    duration: theme.transitions.duration.standard,
                }),
            })}
        >
            <Box
                component="section"
                sx={theme => ({
                    backgroundColor: theme.palette.background.paper,
                    boxShadow: { xs: "none", sm: FRAME_SHADOW },
                    borderRadius: { xs: 0, sm: 2 },
                    overflow: "hidden",
                    border: 1,
                    borderColor: "divider",
                    flex: 1,
                    minHeight: 0,
                    display: "flex",
                    flexDirection: "column",
                })}
            >
                {children}
            </Box>
        </Box>
    );
}
